import { VALIDATE_PASSWORD_MIN } from "constants/index";
import { isPossiblePhoneNumber, isValidPhoneNumber } from "libphonenumber-js";
import * as Yup from "yup";
import YupPassword from "yup-password";
YupPassword(Yup);

export const validate = {
  required: "This field is required.",
  stringRequired: "This field contains string only.",
  numberRequired: "This field contains number only.",
  intRequired: "This field contains integer",
  booleanRequired: "This field must be true or false",
  dateRequired: "This field only allows input of date.",
  minRequired: "This field contains at least 3 characters",
  enumRequired: "Please select an option",
  idNumber: "Số CMT/CCCD phải chứa 9 hoặc 12 số",
  onlyNumber: "This field contains number only.",
  trimRequired: "Không để khoảng trống!",
  phoneNumber: "The format of your phone number is incorrect.",
  email: "The format of your email is incorrect.",
  otp: "The format of your otp is incorrect.",
  password: "The format of your password is incorrect.",
  revenueRequired: "The total ratio must be 100%.",
  numberOfOpeningLength: "Number Of Opening must be greater than 5",
  arrayMax: (maxValue: number) => `Maximum of ${maxValue} file uploads`,
};
export const MAX_QUANTITY_DEC_PREFIX = 2;

const phoneRegExp =
  /^((0|\+?84)(\s|\.)?((3[2-9])|(5[25689])|(7[06-9])|(8[1-6789])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3}))$|(^(0|\+?84)(\s|\.)?((2[0-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{4}))$/;
// const phoneMultiCountryRegExpression = /^[.]$/

const idNumberExp = /^[0-9]{9,12}$/;

const emailRegex =
  /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z0-9]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

export const stringRequired = Yup.string()
  .required(validate.required)
  .typeError(validate.required)
  .trim(validate.required);

export const resetPasswordRequired = Yup.string()
  .required(validate.required)
  .typeError(validate.required)
  .trim(validate.required)
  .min(
    VALIDATE_PASSWORD_MIN,
    ({ min }) => `Passwords must be at least ${min} characters`
  )
  .minLowercase(1, "Password must contain at least 1 lower case letter")
  .minUppercase(1, "Password must contain at least 1 upper case letter")
  .minNumbers(1, "Password must contain at least 1 number")
  .minSymbols(1, "Password must contain at least 1 special character");

export const confirmPasswordRequired = Yup.string()
  .required(validate.required)
  .typeError(validate.required)
  .trim(validate.required)
  .test(
    "confirmPassword",
    `The entered password does not match`,
    (confirmPassword, { parent }) => {
      return confirmPassword === parent?.password;
    }
  );
export const confirmPasswordRequiredV2 = Yup.string()
  .required(validate.required)
  .typeError(validate.required)
  .trim(validate.required)
  .test(
    "password",
    `The entered password does not match`,
    (password, { parent }) => {
      return password === parent?.newPassword;
    }
  );
const passwordRegex =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-=_+{};':"|\\[\]<>?/]).{8,}$/;
export const passwordRequired = Yup.string()
  .required(validate.required)
  .typeError(validate.required)
  .trim(validate.required)
  .test("newPassword", validate.password, (value) => {
    if (value) {
      return !!value.match(new RegExp(passwordRegex));
    }
    return true;
  });
const otpRegex = /^[^\s]{6}$/;
export const otpRequired = Yup.string()
  .required(validate.required)
  .typeError(validate.required)
  .trim(validate.required)
  .test("otpCode", validate.otp, (value) => {
    if (value) {
      return !!value.match(new RegExp(otpRegex));
    }
    return true;
  });

export const objectRequired = Yup.object().required(validate.required);
export const numberRequired = Yup.number()
  .required(validate.required)
  .typeError(validate.required)
  .test(
    "maxDigits",
    `Mục này chỉ nhập số thập phân có tối đa ${MAX_QUANTITY_DEC_PREFIX} số sau dấu chấm`,
    (number) =>
      String(number).includes(".")
        ? String(number).split(".")[1].length <= MAX_QUANTITY_DEC_PREFIX
        : true
  );
export const numberNotRequired = Yup.number()
  .nullable()
  .typeError(validate.required)
  .test(
    "maxDigits",
    `Mục này chỉ nhập số thập phân có tối đa ${MAX_QUANTITY_DEC_PREFIX} số sau dấu chấm`,
    (number) =>
      String(number).includes(".")
        ? String(number).split(".")[1].length <= MAX_QUANTITY_DEC_PREFIX
        : true
  );
export const numberNotRequiredAndMax1DecPart = Yup.number()
  .nullable()
  .typeError(validate.required)
  .test(
    "maxDigits",
    `Mục này chỉ nhập số thập phân có tối đa 1 số sau dấu chấm`,
    (number) =>
      String(number).includes(".")
        ? String(number).split(".")[1].length <= 1
        : true
  );
export const intRequired = Yup.number()
  .integer(validate.intRequired)
  .required(validate.required)
  .typeError(validate.required);
export const phoneRequired = stringRequired.matches(
  phoneRegExp,
  validate.phoneNumber
);

export const phoneNotRequired = Yup.string()
  // .typeError(validate.required)
  // .trim(validate.required)
  // .matches(phoneRegExp, validate.phoneNumber)
  .trim()
  .test("phone", validate.phoneNumber, (value) => {
    if (value) {
      return !!value.match(new RegExp(phoneRegExp));
    }
    return true;
  });

export const idNumberRequired = Yup.string()
  .test("idNumber", validate.idNumber, (value) => {
    return (
      !value || value?.trim()?.length === 9 || value?.trim()?.length === 12
    );
  })
  .matches(idNumberExp, validate.onlyNumber)
  .trim(validate.trimRequired);

export const emailRequiredVal = Yup.string()
  .email(validate.email)
  .trim()
  .test("email", validate.email, (value) => {
    if (value) {
      return !!value.match(new RegExp(emailRegex));
    }
    return true;
  });

export const emailRequired = Yup.string()
  .required(validate.required)
  .email(validate.email)
  .trim()
  .test("email", validate.email, (value) => {
    if (value) {
      return !!value.match(new RegExp(emailRegex));
    }
    return true;
  });

export const booleanRequired = Yup.boolean().required(validate.required);

export const arrayRequired = Yup.array()
  .required(validate.required)
  .typeError(validate.required)
  .min(1, validate.required);

export const arrayMaxLength = (maxValue: number) =>
  Yup.array().max(maxValue, validate.arrayMax(maxValue));

export const revenueRatioRequired = Yup.number()
  .required(validate.required)
  .typeError(validate.required)
  // .nullable()
  .test(
    "maxDigits",
    `Mục này chỉ nhập số thập phân có tối đa ${MAX_QUANTITY_DEC_PREFIX} số sau dấu chấm`,
    (number) =>
      String(number).includes(".")
        ? String(number).split(".")[1].length <= MAX_QUANTITY_DEC_PREFIX
        : true
  )
  .test(
    "validate-revenue-ratio",
    validate.revenueRequired,
    (_, { parent }: any) => {
      const totalRate =
        (parent?.revenueRatio1 ? parent?.revenueRatio1 : 0) +
        (parent?.revenueRatio2 ? parent?.revenueRatio2 : 0) +
        (parent?.revenueRatio3 ? parent?.revenueRatio3 : 0);
      return totalRate === 100;
    }
  );
export const phoneNationRequired = stringRequired
  .test("phoneNumberOne", validate.required, (value) => {
    const info = JSON.parse(value);
    return !!info?.numberValue;
  })
  .test("phoneNumberTwo", validate.phoneNumber, (value) => {
    const info = JSON.parse(value);
    const numberValue = info?.numberValue;
    const countryCode = info?.countryCode;
    const isPossible = isPossiblePhoneNumber(numberValue, countryCode);
    const isValid = isValidPhoneNumber(numberValue, countryCode);
    const result = isPossible && isValid;
    return result;
  });

export const fileRequired = Yup.mixed().required(validate.required);
